import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	assigneeTooltip: {
		id: 'issue-field-assignee.common.read-view.popover.assignee-tooltip',
		defaultMessage: 'Assignee: {name}',
		description: 'Tooltip of the assignee avatar when hovered over',
	},
});
